import { useEffect, useRef } from "react";

interface UseInfiniteScrollSentinelOptions {
  hasMore: boolean;
  onLoadMore: () => void;
  rootId?: string;
  rootMargin?: string;
}

export function useInfiniteScrollSentinel({
  hasMore,
  onLoadMore,
  rootId = "scrollableDiv",
  rootMargin = "200px 0px",
}: UseInfiniteScrollSentinelOptions) {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || !hasMore) return;

    const root = document.getElementById(rootId);
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) onLoadMore();
      },
      { root, rootMargin },
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore, rootId, rootMargin]);

  return sentinelRef;
}
